const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../../core/vault/ActionTypes");
const OpsParentSubChange = require("../vault/OpsParentSubChange");
const SubscriptionSummaryAccount = require("./SubscriptionSummaryAccount");
const CheckoutUtil = require("../util/CheckoutUtil");
const UnderlineView = require("../../office/UnderlineView");
const Policies = require("../../office/Policies");

const styles = require("./styles/ReviewSubscription.css");

module.exports = createReactClass({
	displayName: "ReviewSubscription",

	propTypes: {
		account: PT.object.isRequired,
		setSection: PT.func,
		dispatch: PT.func.isRequired,
	},

	goToSection: function(section) {
		this.props.setSection(section);
	},

	placeOrder: function() {
		// Throttling done to fix T11411.
		this.doSubmit =
			this.doSubmit ||
			_.throttle(
				() => {
					this.props.dispatch({
						type: AT.FINISH_SUBSCRIPTION_CHANGE_REQUEST,
					});
				},
				500,
				{leading: true, trailing: false}
			);
		this.doSubmit();
	},

	onKeyPress: function(section, evt) {
		if (evt.which === 13) {
			this.goToSection(section);
		}
	},

	renderBox: function(groups, title, section, tabIndex) {
		const allElems = [];

		_.each(groups, (group, i) => {
			if (i > 0) allElems.push(<br key={"break" + i} />);
			_.each(group, elem => {
				allElems.push(elem);
			});
		});

		const editButton = (
			<div
				className={styles.edit}
				onClick={() => this.goToSection(section)}
				tabIndex={tabIndex}
				onKeyPress={evt => this.onKeyPress(section, evt)}
			>
				Edit
			</div>
		);

		return (
			<div className={styles.box} key={section + "Group"}>
				<div className={styles.subtitle}>
					{title}
					{editButton}
				</div>
				{allElems}
			</div>
		);
	},

	render: function() {
		const account = this.props.account;

		const infoGroups = CheckoutUtil.renderInfoGroupsAccount(account);

		const boxes = [];
		// TODO: maybe better if CheckoutUtil returns an object instead of an array?
		if (OpsParentSubChange.needsShipping(account)) {
			boxes.push(this.renderBox(infoGroups[1], "Billing", "billing", 1));
			boxes.push(this.renderBox(infoGroups[0], "Shipping", "shipping", 2));
		} else {
			boxes.push(this.renderBox(infoGroups[0], "Billing", "billing", 1));
		}

		return (
			<div className={styles.main}>
				<div className={styles.title}>
					<UnderlineView text={"Review Information"} />
				</div>
				<div className={styles.across}>
					<div className={styles.contentContainer}>
						<div className={styles.content}>
							{boxes}
							<Policies
								subChangePlanType={account.subChangeState.newPlanType}
								subChangeType={account.subChangeState.changeType}
								cannotCancel={!OpsParentSubChange.canCancelSub(account)}
								className={styles.policyBox}
								titleClass={styles.policySubtitle}
							/>
						</div>
					</div>
					<SubscriptionSummaryAccount
						{...this.props}
						showItemize={true}
						onContinue={this.placeOrder}
						buttonText="place order"
						tabIndex={3}
					/>
				</div>
			</div>
		);
	},
});
